import { Router } from '@angular/router';
import { TogetherHeaderLink, TogetherHeaderLinks } from './models/app.models';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'together-header',
    templateUrl: './together.header.html',
    styleUrls: ['together.header.scss'],
    standalone: false
})
export class TogetherHeaderComponent {
  enable_header_links = false;

  /**
   * Header links from app parent.
   *
   * @type {TogetherHeaderLinks}
   * @memberof TogetherHeaderComponent
   */
  @Input() header_links: TogetherHeaderLinks;
}
